import { Transmission } from '@yleisradio/areena-types/domain/transmission';
import { impressionDataAttributeKeys } from '../analytics/getDataAttributesImpression';
import { ListStyle } from '@yleisradio/areena-types';
import { is_16_9_image, is_1_1_image, is_9_13_image } from './list/listStyle';

// this is ~copypasta of https://github.com/StephanHoyer/classies
export const cls = (
  def: Record<string, boolean | undefined | null | string | number>,
  separator = ' '
): string => {
  let classes;

  for (const cls in def) {
    if (def[cls]) {
      classes = classes == null ? cls : classes + separator + cls;
    }
  }
  return classes || '';
};

export const getCurrentTransmission = (
  currentTime: number,
  transmissions?: Transmission[]
) => {
  return transmissions?.find(t => Date.parse(t.endTime) > currentTime);
};

export const getTransmissionSecondaryText = (
  currentTransmission: Transmission | undefined,
  cardTitle?: string
) => {
  if (currentTransmission?.title && currentTransmission.title !== cardTitle) {
    return currentTransmission.title;
  }
};

export const isDateStringInPast = (
  now: number,
  isoDateString: string | undefined
) => {
  if (isoDateString) {
    const expiresTime = Date.parse(isoDateString);

    return expiresTime - now < 0;
  }
  return false;
};

export const dataAttributeKeys = {
  broadcastStartDate: 'data-broadcast-start-date',
  broadcastEndDate: 'data-broadcast-end-date',
  ...impressionDataAttributeKeys,
} as const;

export function getRefreshDelay(timeToRefresh: number, timeNow: number) {
  return timeToRefresh - timeNow + Math.round(500 + Math.random() * 4500);
}

/**
 * Returns list height in rem-values.
 *
 * Card height measurements are from src/client/styles/variables.scss.
 * Title height measurements are from src/client/View/card/CardRow.module.scss
 * @returns list height in rems. Null in case image style is missing.
 */
export function getListHeightRemByListStyle(
  listStyle: ListStyle,
  hasTitle: boolean
) {
  const listBottomMargin = 1;
  const titleHeight = hasTitle ? 2.375 : 0;
  const titleBottomMargin = hasTitle ? 0.3 : 0;

  let cardHeight = null;

  if (is_16_9_image(listStyle)) {
    cardHeight = 9;
  } else if (is_9_13_image(listStyle)) {
    cardHeight = 15.875;
  } else if (is_1_1_image(listStyle)) {
    cardHeight = 10;
  }

  return cardHeight === null
    ? null
    : cardHeight + listBottomMargin + titleHeight + titleBottomMargin;
}
